import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import DealFinder from "./pages/DealFinder";
import DealDetail from "./pages/DealDetail";
import Market from "./pages/Market";
import InvestmentCommittee from "./pages/InvestmentCommittee";
import DataQuality from "./pages/DataQuality";
import Watchlist from "./pages/Watchlist";
import Alerts from "./pages/Alerts";
import Sources from "./pages/Sources";
import Settings from "./pages/Settings";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="*"
                            element={
                                <ProtectedRoute>
                                    <Layout>
                                        <Routes>
                                            <Route path="/" element={<Overview />} />
                                            <Route path="/deals" element={<DealFinder />} />
                                            <Route path="/deals/:id" element={<DealDetail />} />
                                            <Route path="/market" element={<Market />} />
                                            <Route path="/committee" element={<InvestmentCommittee />} />
                                            <Route path="/quality" element={<DataQuality />} />
                                            <Route path="/watchlist" element={<Watchlist />} />
                                            <Route path="/alerts" element={<Alerts />} />
                                            <Route path="/sources" element={<Sources />} />
                                            <Route path="/settings" element={<Settings />} />
                                        </Routes>
                                    </Layout>
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
